import type { Catalogue } from './en.ts';

/**
 * Tamil. Machine-assisted first pass — every string here needs a native
 * reviewer before this locale is offered publicly. Missing keys fall back to
 * English rather than showing a key, so a partial catalogue is safe to ship
 * behind a flag.
 */
export const ta: Catalogue = {
  'app.name': 'ரம்மி',
  'app.tagline': 'உங்கள் ஆட்களுக்கான ஒரு மேசை. பணம் எதுவும் இல்லை.',

  'auth.heading': 'அமருங்கள்',
  'auth.or': 'அல்லது',
  'auth.email.label': 'மின்னஞ்சல்',
  'auth.password.label': 'கடவுச்சொல்',
  'auth.signin': 'உள்நுழைக',
  'auth.signup': 'கணக்கு உருவாக்கு',
  'auth.haveAccount': 'ஏற்கனவே உறுப்பினரா?',
  'auth.newHere': 'புதியவரா?',
  'auth.profile.heading': 'உங்கள் பாணியைத் தேர்வு செய்க',
  'auth.shuffle': 'மாற்று',
  'auth.enter': 'கிளப்பில் நுழைக',
  'auth.error.invalid-credentials': 'மின்னஞ்சல் அல்லது கடவுச்சொல் தவறு.',
  'auth.error.weak-password': 'குறைந்தது 8 எழுத்துகள் வேண்டும்.',
  'lobby.hey': 'வணக்கம்',
  'lobby.sub': 'இன்று யாருடன் விளையாடலாம்?',
  'lobby.practice': 'பயிற்சி',
  'lobby.practice.note': 'ஒரே தட்டில் போட்களுடன் மேசை தயார்.',
  'lobby.joinByCode': 'குறியீடு உள்ளதா?',
  'settings.signout': 'வெளியேறு',
  'auth.guest': 'விருந்தினராக விளையாடு',
  'auth.retry': 'மீண்டும் முயற்சி',
  'auth.name.label': 'மேசை உங்களை என்ன அழைக்க வேண்டும்?',
  'auth.name.placeholder': 'உங்கள் பெயர்',
  'auth.adult': 'எனக்கு 18 வயது நிரம்பியது',
  'auth.adult.note':
    'இது பெரியவர்களுக்கான மேசை. வைப்பு இல்லை, எடுப்பு இல்லை, வெற்றித்தொகை இல்லை — ஒவ்வொரு அமர்விலும் புள்ளிகள் மீளத் தொடங்கும்.',

  'lobby.heading': 'கூடம்',
  'lobby.friends': 'நண்பர்கள்',
  'lobby.friends.empty': 'ஒரு மேசையில் விளையாடுங்கள், அங்குள்ளவர்கள் இங்கே தோன்றுவார்கள்.',
  'lobby.friends.explain': 'சேர்ந்து விளையாடுவதால்தான் நட்பு உருவாகும். தேடல் இல்லை.',
  'lobby.rooms': 'சமீபத்திய அறைகள்',
  'lobby.rooms.empty': 'இன்னும் ஒன்றும் இல்லை.',
  'lobby.create': 'அறையை உருவாக்கு',
  'lobby.join': 'சேர்',
  'lobby.invite': 'அழை',

  'presence.online': 'இணைப்பில்',
  'presence.at-table': '{room} இல்',
  'presence.away': 'விலகி',
  'presence.offline': 'இணைப்பில் இல்லை',

  'room.heading': 'அறை {id}',
  'room.format': 'வடிவம்',
  'room.seats': 'இருக்கைகள்',
  'room.turnTimer': 'ஆட்ட நேரம்',
  'room.turnTimer.value': '{seconds, number} வினாடிகள்',
  'room.guard': 'அறிவிப்புக் காவல்',
  'room.guard.on': 'இயக்கம்',
  'room.guard.off': 'நிறுத்தம்',
  'room.invite': 'அழைப்பு இணைப்பு',
  'room.copy': 'நகலெடு',
  'room.copied': 'நகலெடுக்கப்பட்டது',
  'room.addBot': 'பயிற்சி எதிராளியைச் சேர்',
  'room.start': 'அமர்வைத் தொடங்கு',
  'room.start.hint': 'தொடங்க இரண்டு இருக்கைகள் தேவை.',
  'room.leave': 'வெளியேறு',
  'room.host': 'நடத்துநர்',
  'room.you': 'நீங்கள்',
  'room.decks': 'இரண்டு இருக்கைகளுக்கு ஒரு கட்டும் ஒரு ஜோக்கரும். மூன்று அல்லது அதற்கு மேல் இரண்டு கட்டுகள்.',
  'room.bot': 'பயிற்சி',

  'format.deals-2': 'டீல் · 2 கைகள்',
  'format.deals-3': 'டீல் · 3 கைகள்',
  'format.deals-6': 'டீல் · 6 கைகள்',
  'format.pool-101': 'பூல் 101',
  'format.pool-201': 'பூல் 201',

  'table.yourTurn': 'உங்கள் முறை',
  'table.turnOf': '{name} யோசிக்கிறார்',
  'table.discard': 'போடு',
  'table.declare': 'அறிவி',
  'table.drop': 'விலகு',
  'table.sort': 'வரிசை',
  'table.undo': 'வரிசையை நீக்கு',
  'table.closed': 'மூடிய கட்டு',
  'table.closed.count': '{count, plural, one {# சீட்டு} other {# சீட்டுகள்}} மீதம்',
  'table.open': 'திறந்த குவியல்',
  'table.open.empty': 'காலி',
  'table.wild': 'வைல்டு ஜோக்கர்',
  'table.wild.short': '{rank} வைல்டு',
  'table.wild.explain':
    '{decks, plural, one {இந்தக் கையில் ஒவ்வொரு {rank}ம் வைல்டு.} other {இந்தக் கையில் ஒவ்வொரு {rank}ம் வைல்டு, இரு கட்டுகளிலும்.}}',
  'table.points': 'இப்போது கை முடிந்தால்: {points, number}',
  'table.yourScore': 'உங்கள் மொத்தம்',
  'table.pointsReady': 'செல்லுபடியான கை. அறிவிக்கலாம்.',
  'table.handOf': 'கை {n, number}',
  'table.handOfTotal': '{total, number} இல் கை {n, number}',
  'table.reconnecting': 'மீண்டும் இணைகிறது',
  'table.leave': 'மேசையை விட்டு வெளியேறு',
  'table.eliminated': 'வெளியே',
  'seat.cards': '{count, plural, one {# சீட்டு} other {# சீட்டுகள்}}',
  'points.short': '{points, number} புள்ளி',

  'group.pure': 'தூய வரிசை',
  'group.impure': 'வரிசை',
  'group.set': 'செட்',
  'group.incomplete': 'இன்னும் சேர்க்கை இல்லை',
  'group.new': 'புதிய குழு',

  'declare.heading': 'அறிவிப்பு',
  'declare.explain': 'சேவையகம் இதைத்தான் பார்க்கும்.',
  'declare.finish': 'இறுதிச் சீட்டு',
  'declare.confirm': 'அறிவிப்பை உறுதிசெய்',
  'declare.cancel': 'திரும்பு',
  'declare.valid': 'இரண்டு வரிசைகள், ஒன்று தூய்மையானது. இது நிற்கும்.',

  'summary.heading': 'கை {n, number}',
  'summary.points': 'புள்ளிகள்',
  'summary.total': 'மொத்தம்',
  'summary.reentry': '{from, number} இல் 201 தாண்டியது · {to, number} இல் மீள்பிரவேசம்',
  'summary.continue': 'தொடர்',
  'outcome.won': 'வென்றார்',
  'outcome.lost': 'தோற்றார்',

  'session.heading': 'அமர்வு முடிந்தது',
  'session.winner': '{name} வென்றார்',
  'session.rematch': 'மீண்டும்',
  'session.leave': 'வெளியேறு',
  'session.details.show': 'அமர்வு விவரங்களைக் காண்க',
  'session.details.hide': 'அமர்வு விவரங்களை மூடு',
  'session.hands': '{n, plural, one {# கை} other {# கைகள்}}',
  'session.hand': 'கை',
  'session.margin': '{points, number} புள்ளி வித்தியாசத்தில் வெற்றி',
  'session.margin.none': 'உச்சியில் சமநிலை',
  'session.celebrate': 'மீண்டும் கொண்டாடு',
  'session.you': 'நீங்கள்',
  'session.out': 'வெளியே',
  'session.outAt': 'கை {n, number} இல் வெளியே',
  'session.reentry': '{to, number} இல் மீள்பிரவேசம் (கை {n, number})',
  'session.reentry.note':
    'மீள்பிரவேசம் மதிப்பெண்ணை ஆட்டத்தில் உள்ள அதிகபட்சத்திற்கு மாற்றுகிறது, எனவே கைகளின் கூட்டுத்தொகை கீழுள்ள மொத்தத்தை விட அதிகமாக இருக்கலாம்.',
  'session.tab.standings': 'நிலைப்பட்டியல்',
  'session.tab.progress': 'முன்னேற்றம்',
  'session.tab.hands': 'கைகள்',
  'session.stat.won': 'வென்ற கைகள்',
  'session.stat.average': 'கைக்கு சராசரி',
  'session.stat.best': 'சிறந்த கை',
  'session.stat.drops': 'ட்ராப்',
  'session.award.wins': 'அதிக கைகள் வென்றவர்',
  'session.award.steady': 'மிக நிலையானவர்',
  'session.award.tight': 'மிக நெருக்கமானது',
  'session.award.wins.value': '{n, plural, one {# கை} other {# கைகள்}}',
  'session.award.points.value': '{points, number} புள்ளி',
  'session.chart.hand': 'கை {n, number} க்குப் பிறகு',
  'session.chart.start': 'முதல் கைக்கு முன்',
  'session.chart.empty': 'எந்தக் கையும் விளையாடப்படவில்லை.',

  'settings.heading': 'அமைப்புகள்',
  'settings.theme': 'தோற்றம்',
  'settings.language': 'மொழி',
  'settings.close': 'மூடு',
};
